import { TransferUploadActionTypes } from './actions';
import initialState from './initial-state';

export default function (state = initialState, action) {
  switch (action.type) {
    case TransferUploadActionTypes.RESET_UPLOAD_PROGRESS:
      return {
        ...state,
        progress: {
          ...initialState.progress,
        },
      };

    case TransferUploadActionTypes.SET_LAST_UPDATE:
      return {
        ...state,
        progress: {
          ...state.progress,
          lastUpdate: Date.now(),
        },
      };

    case TransferUploadActionTypes.UPDATE_UPLOAD_TIME: {
      const timePassedSinceLastUpdate =
        (Date.now() - state.progress.lastUpdate) / 1000;
      const delta = action.bytesSentSoFar - state.progress.bytesSentSoFar;
      const bytesPerSecond = delta / timePassedSinceLastUpdate;

      const bytesPerSecondLog = [
        bytesPerSecond,
        ...state.progress.bytesPerSecondLog,
      ];

      const averageBytesPerSecond =
        bytesPerSecondLog.reduce(
          (total, bytesPerSecondLogEntry) => total + bytesPerSecondLogEntry,
          0
        ) / bytesPerSecondLog.length;

      const remainingTime = Math.round(
        (action.currentSize - action.bytesSentSoFar) / averageBytesPerSecond
      );

      return {
        ...state,
        progress: {
          ...state.progress,
          remainingTime,
          bytesSentSoFar: action.bytesSentSoFar,
          bytesPerSecondLog,
        },
      };
    }

    case TransferUploadActionTypes.UPDATE_UPLOAD_PROGRESS: {
      let percentage = Math.min(
        100,
        Math.round((action.bytesSentSoFar / action.currentSize) * 100)
      );

      if (Number.isNaN(percentage)) {
        percentage = 0;
      }

      const duration = (Date.now() - action.transferUploadStartedAt) / 1000;

      return {
        ...state,
        progress: {
          ...state.progress,
          percentage,
          duration,
          progressBytesSentSoFar: action.bytesSentSoFar,
        },
      };
    }

    default:
      return state;
  }
}
